import { finalizeBasket, selectBasketIsEmpty, selectBasketPaymentInProgress, updatePaymentInProgress } from 'containers/OrderDetails/basketSlice'
import { useHistory, useLocation } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import { useReduxDispatch, useReduxSelector } from 'store'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import Loading from 'components/Loading'
import { GET } from 'rest/request'
import * as urls from 'rest/urls'
import './style.scss'

interface Response {
  sold: boolean
  contracts?: any[]
  orderTitle?: string
  orderNumber?: string
  orderSummary?: string
  paymentStatus: 'INIT' | 'PENDING' | 'SUCCESS' | 'FAILURE'
}

const PaymentStatus: React.FC = () => {
  const isBasketEmpty = useReduxSelector(selectBasketIsEmpty)
  const paymentInProgress = useReduxSelector(selectBasketPaymentInProgress)
  const [data, setData] = useState<Response | null>(null)
  const { search } = useLocation()

  const currentPaymentInProgress = useRef(paymentInProgress)
  currentPaymentInProgress.current = paymentInProgress

  const { t } = useTranslation('payment')
  const dispatch = useReduxDispatch()
  const { replace } = useHistory()

  useEffect(() => {
    let timeout: basic.SetTimeout
    const getStatus = async () => {
      const response: Response = await GET(`${urls.paymentCompletedStatus}${search}`)
      if (response) {
        if (response.paymentStatus === 'SUCCESS' || response.paymentStatus === 'FAILURE') {
          if (currentPaymentInProgress.current && response.paymentStatus === 'SUCCESS') {
            dispatch(finalizeBasket(response.contracts))
            replace('/newwarehouse')

          } else {
            if (currentPaymentInProgress.current) {
              dispatch(updatePaymentInProgress(false))
            }
            setData(response)
          }
        } else {
          timeout = setTimeout(getStatus, 3_000)
        }
      }
    }

    if (search) {
      getStatus()
      return () => {
        if (timeout) {
          clearTimeout(timeout)
        }
      }
    }
  }, [dispatch, replace, search])

  return (
    <div className='paymentStatus'>
      <div className='title'>
        <div>{t('paymentStatus')}</div>
        {data
          ? <div>{t(data.paymentStatus === 'SUCCESS' ? 'paymentSuccessful' : 'paymentFailed')}!</div>
          : <div>{t('waitingForPaymentStatus')}</div>}
      </div>

      {data
        ? <div className='paymentStatus__main__wrapper'>
          <div className='paymentStatus__main'>
            <div className='paymentStatus__main__title'>
              {data?.orderTitle || 'Numer zamówienia'}{data?.orderNumber ? <>: <b>{data.orderNumber}</b></> : ''}
            </div>
            {data?.orderSummary
              ? <div className='paymentStatus__main__description' dangerouslySetInnerHTML={{ __html: data.orderSummary }} />
              : <p>{t('pleaseCheckYourEmailAndContactUsIfNeeded')}</p>}
            {!isBasketEmpty && data.paymentStatus === 'FAILURE'
              ? <div className='paymentStatus__main__buttons'>
                <ArrowBtn
                  enlarged
                  text={t('retryPayment')}
                  action={() => {
                    replace('/order/payment')
                  }} />
                <BackBtn
                  text={t('homePage')}
                  action={() => {
                    replace('/')
                  }}
                />
              </div>
              : <ArrowBtn
                enlarged
                text={t('homePage')}
                action={() => {
                  replace('/')
                }} />}
          </div>
        </div>
        : <Loading middleOfPage />}
    </div>
  )
}

export default PaymentStatus